import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleNamePipe } from './module-name.pipe';



@NgModule({
  declarations: [
    ModuleNamePipe
  ],
  imports: [
    CommonModule
  ],
  exports:[
    ModuleNamePipe
  ]
})
export class ModuleNameModule { }